// extracted by mini-css-extract-plugin
export default {"chip":"nav_document_analyzer_text-module__chip--3FyDg"};